"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[693],{

/***/ 53497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SvgBank; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.9998 26.4992H26.9997V12.4997H29.9998C30.9072 12.4997 31.7001 11.8892 31.9324 11.0133C32.1659 10.1363 31.7792 9.21358 30.992 8.76323L16.9921 0.763634C16.6844 0.587794 16.3417 0.499664 15.9999 0.499664C15.658 0.499664 15.3152 0.587794 15.0077 0.763634L1.00764 8.76323C0.220465 9.21358 -0.166247 10.1363 0.0672129 11.0133C0.299737 11.8892 1.0926 12.4997 1.99984 12.4997H4.9999V26.4992H1.99984C0.895393 26.4992 -0.000107162 27.3951 -0.000107162 28.4995V32.4996H31.9999V28.4995C31.9999 27.3951 31.1044 26.4992 29.9998 26.4992ZM2.99977 10.4995C2.39054 10.4995 2.72444 10.0854 2.98717 9.93528C3.21768 9.8035 13.0253 4.19976 15.4578 2.80931C15.8026 2.61191 16.1825 2.60393 16.5047 2.78744C18.8651 4.13606 28.7069 9.7593 29.0047 9.93045C29.3437 10.1245 29.6562 10.4995 28.9999 10.4995C28.3437 10.4995 3.60914 10.4995 2.99977 10.4995ZM24.9998 12.4997V26.4992H22.9998V12.4997H24.9998ZM20.9999 12.4997V26.4992H18.9998V12.4997H20.9999ZM16.9998 12.4997V26.4992H14.9998V12.4997H16.9998ZM12.9999 12.4997V26.4992H10.9998V12.4997H12.9999ZM8.99982 12.4997V26.4992H6.99984V12.4997H8.99982ZM29.9998 30.4996H1.99984V29.4996C1.99984 28.947 2.44721 28.4995 2.99977 28.4995H28.9999C29.5525 28.4995 29.9998 28.947 29.9998 29.4996V30.4996Z",
  fill: "white"
});

function SvgBank({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMiAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOS45OTk4IDI2LjQ5OTJIMjYuOTk5N1YxMi40OTk3SDI5Ljk5OThDMzAuOTA3MiAxMi40OTk3IDMxLjcwMDEgMTEuODg5MiAzMS45MzI0IDExLjAxMzNDMzIuMTY1OSAxMC4xMzYzIDMxLjc3OTIgOS4yMTM1OCAzMC45OTIgOC43NjMyM0wxNi45OTIxIDAuNzYzNjM0QzE2LjY4NDQgMC41ODc3OTQgMTYuMzQxNyAwLjQ5OTY2NCAxNS45OTk5IDAuNDk5NjY0QzE1LjY1OCAwLjQ5OTY2NCAxNS4zMTUyIDAuNTg3Nzk0IDE1LjAwNzcgMC43NjM2MzRMMS4wMDc2NCA4Ljc2MzIzQzAuMjIwNDY1IDkuMjEzNTggLTAuMTY2MjQ3IDEwLjEzNjMgMC4wNjcyMTI5IDExLjAxMzNDMC4yOTk3MzcgMTEuODg5MiAxLjA5MjYgMTIuNDk5NyAxLjk5OTg0IDEyLjQ5OTdINC45OTk5VjI2LjQ5OTJIMS45OTk4NEMwLjg5NTM5MyAyNi40OTkyIC0wLjAwMDEwNzE2MiAyNy4zOTUxIC0wLjAwMDEwNzE2MiAyOC40OTk1VjMyLjQ5OTZIMzEuOTk5OVYyOC40OTk1QzMxLjk5OTkgMjcuMzk1MSAzMS4xMDQ0IDI2LjQ5OTIgMjkuOTk5OCAyNi40OTkyWk0yLjk5OTc3IDEwLjQ5OTVDMi4zOTA1NCAxMC40OTk1IDIuNzI0NDQgMTAuMDg1NCAyLjk4NzE3IDkuOTM1MjhDMy4yMTc2OCA5LjgwMzUgMTMuMDI1MyA0LjE5OTc2IDE1LjQ1NzggMi44MDkzMUMxNS44MDI2IDIuNjExOTEgMTYuMTgyNSAyLjYwMzkzIDE2LjUwNDcgMi43ODc0NEMxOC44NjUxIDQuMTM2MDYgMjguNzA2OSA5Ljc1OTMgMjkuMDA0NyA5LjkzMDQ1QzI5LjM0MzcgMTAuMTI0NSAyOS42NTYyIDEwLjQ5OTUgMjguOTk5OSAxMC40OTk1QzI4LjM0MzcgMTAuNDk5NSAzLjYwOTE0IDEwLjQ5OTUgMi45OTk3NyAxMC40OTk1Wk0yNC45OTk4IDEyLjQ5OTdWMjYuNDk5MkgyMi45OTk4VjEyLjQ5OTdIMjQuOTk5OFpNMjAuOTk5OSAxMi40OTk3VjI2LjQ5OTJIMTguOTk5OFYxMi40OTk3SDIwLjk5OTlaTTE2Ljk5OTggMTIuNDk5N1YyNi40OTkySDE0Ljk5OThWMTIuNDk5N0gxNi45OTk4Wk0xMi45OTk5IDEyLjQ5OTdWMjYuNDk5MkgxMC45OTk4VjEyLjQ5OTdIMTIuOTk5OVpNOC45OTk4MiAxMi40OTk3VjI2LjQ5OTJINi45OTk4NFYxMi40OTk3SDguOTk5ODJaTTI5Ljk5OTggMzAuNDk5NkgxLjk5OTg0VjI5LjQ5OTZDMS45OTk4NCAyOC45NDcgMi40NDcyMSAyOC40OTk1IDIuOTk5NzcgMjguNDk5NUgyOC45OTk5QzI5LjU1MjUgMjguNDk5NSAyOS45OTk4IDI4Ljk0NyAyOS45OTk4IDI5LjQ5OTZWMzAuNDk5NloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=");


/***/ }),

/***/ 80305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SvgCard; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.0623 0.499451H30.9374C32.0774 0.499451 32.9998 1.3941 32.9998 2.49972V22.4998C32.9998 23.6051 32.0774 24.4996 30.9374 24.4996H2.0623C0.922357 24.4996 -0.000106812 23.6051 -0.000106812 22.4998V2.49972C-0.000106812 1.3941 0.922357 0.499451 2.0623 0.499451ZM29.9062 22.4998C30.4761 22.4998 30.9374 22.0525 30.9374 21.4997V12.4998H2.0623V21.4997C2.0623 22.0525 2.5236 22.4998 3.09359 22.4998H29.9062ZM2.0623 10.4998H30.9374V8.49982H2.0623V10.4998ZM2.0623 6.49969H30.9374V3.49972C30.9374 2.94689 30.4761 2.49972 29.9062 2.49972H3.09359C2.5236 2.49972 2.0623 2.94689 2.0623 3.49972V6.49969ZM15.4686 18.4997H7.21854C6.64863 18.4997 6.18732 18.0525 6.18732 17.4996C6.18732 16.947 6.64863 16.4996 7.21854 16.4996H15.4686C16.0385 16.4996 16.4998 16.947 16.4998 17.4996C16.4998 18.0525 16.0385 18.4997 15.4686 18.4997Z",
  fill: "white"
});

function SvgCard({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAzMyAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjA2MjMgMC40OTk0NTFIMzAuOTM3NEMzMi4wNzc0IDAuNDk5NDUxIDMyLjk5OTggMS4zOTQxIDMyLjk5OTggMi40OTk3MlYyMi40OTk4QzMyLjk5OTggMjMuNjA1MSAzMi4wNzc0IDI0LjQ5OTYgMzAuOTM3NCAyNC40OTk2SDIuMDYyM0MwLjkyMjM1NyAyNC40OTk2IC0wLjAwMDEwNjgxMiAyMy42MDUxIC0wLjAwMDEwNjgxMiAyMi40OTk4VjIuNDk5NzJDLTAuMDAwMTA2ODEyIDEuMzk0MSAwLjkyMjM1NyAwLjQ5OTQ1MSAyLjA2MjMgMC40OTk0NTFaTTI5LjkwNjIgMjIuNDk5OEMzMC40NzYxIDIyLjQ5OTggMzAuOTM3NCAyMi4wNTI1IDMwLjkzNzQgMjEuNDk5N1YxMi40OTk4SDIuMDYyM1YyMS40OTk3QzIuMDYyMyAyMi4wNTI1IDIuNTIzNiAyMi40OTk4IDMuMDkzNTkgMjIuNDk5OEgyOS45MDYyWk0yLjA2MjMgMTAuNDk5OEgzMC45Mzc0VjguNDk5ODJIMi4wNjIzVjEwLjQ5OThaTTIuMDYyMyA2LjQ5OTY5SDMwLjkzNzRWMy40OTk3MkMzMC45Mzc0IDIuOTQ2ODkgMzAuNDc2MSAyLjQ5OTcyIDI5LjkwNjIgMi40OTk3MkgzLjA5MzU5QzIuNTIzNiAyLjQ5OTcyIDIuMDYyMyAyLjk0Njg5IDIuMDYyMyAzLjQ5OTcyVjYuNDk5NjlaTTE1LjQ2ODYgMTguNDk5N0g3LjIxODU0QzYuNjQ4NjMgMTguNDk5NyA2LjE4NzMyIDE4LjA1MjUgNi4xODczMiAxNy40OTk2QzYuMTg3MzIgMTYuOTQ3IDYuNjQ4NjMgMTYuNDk5NiA3LjIxODU0IDE2LjQ5OTZIMTUuNDY4NkMxNi4wMzg1IDE2LjQ5OTYgMTYuNDk5OCAxNi45NDcgMTYuNDk5OCAxNy40OTk2QzE2LjQ5OTggMTguMDUyNSAxNi4wMzg1IDE4LjQ5OTcgMTUuNDY4NiAxOC40OTk3WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==");


/***/ }),

/***/ 65497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SvgWallet; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.9999 32.4996H1.99984C0.895198 32.4996 -9.15527e-05 31.6041 -9.15527e-05 30.4998V10.4997V8.49942L25.9998 0.499686C26.4686 0.374701 26.8539 0.281006 27.2498 0.437211C27.7636 0.639895 27.9999 0.947161 27.9999 1.49953V8.49942C29.1044 8.49942 29.9998 9.39515 29.9998 10.4997V30.4998C29.9998 31.6041 29.1044 32.4996 27.9999 32.4996ZM25.9998 2.49966L6.50005 8.49942H25.9998V2.49966ZM27.9999 21.4996C27.9999 20.9475 27.9999 21.2497 27.9999 20.4996H23.9999C23.9999 20.9471 23.9999 20.9475 23.9999 21.4996C23.9999 22.052 23.9999 21.853 23.9999 22.4996H27.9999C27.9999 21.812 27.9999 22.0517 27.9999 21.4996ZM1.99974 10.4996L26.9998 10.4997C27.5521 10.4997 27.9999 10.9472 27.9999 11.4997V18.4996H22.9998C22.4476 18.4996 21.9998 18.9472 21.9998 19.4998V23.4994C21.9998 24.052 22.4476 24.4996 22.9998 24.4996H27.9999V29.4995C27.9999 30.052 27.5521 30.4998 26.9998 30.4998H2.99987C2.44758 30.4998 1.99984 30.052 1.99984 29.4995C1.99984 29.4995 1.99974 11.187 1.99974 10.4996Z",
  fill: "white"
});

function SvgWallet({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMCAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNy45OTk5IDMyLjQ5OTZIMS45OTk4NEMwLjg5NTE5OCAzMi40OTk2IC05LjE1NTI3ZS0wNSAzMS42MDQxIC05LjE1NTI3ZS0wNSAzMC40OTk4VjEwLjQ5OTdWOC40OTk0MkwyNS45OTk4IDAuNDk5Njg2QzI2LjQ2ODYgMC4zNzQ3MDEgMjYuODUzOSAwLjI4MTAwNiAyNy4yNDk4IDAuNDM3MjExQzI3Ljc2MzYgMC42Mzk4OTUgMjcuOTk5OSAwLjk0NzE2MSAyNy45OTk5IDEuNDk5NTNWOC40OTk0MkMyOS4xMDQ0IDguNDk5NDIgMjkuOTk5OCA5LjM5NTE1IDI5Ljk5OTggMTAuNDk5N1YzMC40OTk4QzI5Ljk5OTggMzEuNjA0MSAyOS4xMDQ0IDMyLjQ5OTYgMjcuOTk5OSAzMi40OTk2Wk0yNS45OTk4IDIuNDk5NjZMNi41MDAwNSA4LjQ5OTQySDI1Ljk5OThWMi40OTk2NlpNMjcuOTk5OSAyMS40OTk2QzI3Ljk5OTkgMjAuOTQ3NSAyNy45OTk5IDIxLjI0OTcgMjcuOTk5OSAyMC40OTk2SDIzLjk5OTlDMjMuOTk5OSAyMC45NDcxIDIzLjk5OTkgMjAuOTQ3NSAyMy45OTk5IDIxLjQ5OTZDMjMuOTk5OSAyMi4wNTIgMjMuOTk5OSAyMS44NTMgMjMuOTk5OSAyMi40OTk2SDI3Ljk5OTlDMjcuOTk5OSAyMS44MTIgMjcuOTk5OSAyMi4wNTE3IDI3Ljk5OTkgMjEuNDk5NlpNMS45OTk3NCAxMC40OTk2TDI2Ljk5OTggMTAuNDk5N0MyNy41NTIxIDEwLjQ5OTcgMjcuOTk5OSAxMC45NDcyIDI3Ljk5OTkgMTEuNDk5N1YxOC40OTk2SDIyLjk5OThDMjIuNDQ3NiAxOC40OTk2IDIxLjk5OTggMTguOTQ3MiAyMS45OTk4IDE5LjQ5OThWMjMuNDk5NEMyMS45OTk4IDI0LjA1MiAyMi40NDc2IDI0LjQ5OTYgMjIuOTk5OCAyNC40OTk2SDI3Ljk5OTlWMjkuNDk5NUMyNy45OTk5IDMwLjA1MiAyNy41NTIxIDMwLjQ5OTggMjYuOTk5OCAzMC40OTk4SDIuOTk5ODdDMi40NDc1OCAzMC40OTk4IDEuOTk5ODQgMzAuMDUyIDEuOTk5ODQgMjkuNDk5NUMxLjk5OTg0IDI5LjQ5OTUgMS45OTk3NCAxMS4xODcgMS45OTk3NCAxMC40OTk2WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==");


/***/ }),

/***/ 46293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SvgArrowQuestion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.03107 1.02925C0.030905 1.29372 0.13229 1.55846 0.33482 1.75965L5.30622 6.70085C5.70736 7.09944 6.35474 7.09944 6.75587 6.70085L11.7273 1.75965C12.1302 1.35909 12.1325 0.707232 11.7323 0.303939C11.332 -0.099618 10.6807 -0.10184 10.2776 0.298857L6.03096 4.51957L1.78437 0.298857C1.38133 -0.10184 0.730025 -0.099618 0.329735 0.303939C0.13055 0.504612 0.03107 0.766995 0.03107 1.02925Z",
  fill: "#A8A8A8"
});

function SvgArrowQuestion({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEzIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4wMzEwNyAxLjAyOTI1QzAuMDMwOTA1IDEuMjkzNzIgMC4xMzIyOSAxLjU1ODQ2IDAuMzM0ODIgMS43NTk2NUw1LjMwNjIyIDYuNzAwODVDNS43MDczNiA3LjA5OTQ0IDYuMzU0NzQgNy4wOTk0NCA2Ljc1NTg3IDYuNzAwODVMMTEuNzI3MyAxLjc1OTY1QzEyLjEzMDIgMS4zNTkwOSAxMi4xMzI1IDAuNzA3MjMyIDExLjczMjMgMC4zMDM5MzlDMTEuMzMyIC0wLjA5OTYxOCAxMC42ODA3IC0wLjEwMTg0IDEwLjI3NzYgMC4yOTg4NTdMNi4wMzA5NiA0LjUxOTU3TDEuNzg0MzcgMC4yOTg4NTdDMS4zODEzMyAtMC4xMDE4NCAwLjczMDAyNSAtMC4wOTk2MTggMC4zMjk3MzUgMC4zMDM5MzlDMC4xMzA1NSAwLjUwNDYxMiAwLjAzMTA3IDAuNzY2OTk1IDAuMDMxMDcgMS4wMjkyNVoiIGZpbGw9IiNBOEE4QTgiLz4KPC9zdmc+Cg==");


/***/ }),

/***/ 53784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SvgCart; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.4791 2.73186C15.1008 2.26856 14.5357 1.9999 13.939 1.9999H3.98257V0.999951C3.98257 0.447545 3.53662 0 2.98688 0H0.9956C0.445854 0 0 0.447545 0 0.999951C0 1.55213 0.445854 1.9999 0.9956 1.9999H1.99128V3.99986V8.99992C1.99128 10.1045 2.88274 10.9999 3.98257 10.9999H12.9434C13.8927 10.9999 14.7099 10.327 14.896 9.39202L15.8917 4.39215C16.0087 3.80458 15.8572 3.19517 15.4791 2.73186ZM3.98257 8.99992V3.99986H13.939L12.9434 8.99992H3.98257ZM2.98688 11.9998C1.88714 11.9998 0.9956 12.8952 0.9956 13.9998C0.9956 15.1045 1.88714 15.9999 2.98688 15.9999C4.08671 15.9999 4.97825 15.1045 4.97825 13.9998C4.97825 12.8952 4.08671 11.9998 2.98688 11.9998ZM10.9521 13.9998C10.9521 12.8952 11.8436 11.9998 12.9434 11.9998C14.0431 11.9998 14.9347 12.8952 14.9347 13.9998C14.9347 15.1045 14.0431 15.9999 12.9434 15.9999C11.8436 15.9999 10.9521 15.1045 10.9521 13.9998Z",
  fill: "black"
});

function SvgCart({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS40NzkxIDIuNzMxODZDMTUuMTAwOCAyLjI2ODU2IDE0LjUzNTcgMS45OTk5IDEzLjkzOSAxLjk5OTlIMy45ODI1N1YwLjk5OTk1MUMzLjk4MjU3IDAuNDQ3NTQ1IDMuNTM2NjIgMCAyLjk4Njg4IDBIMC45OTU2QzAuNDQ1ODU0IDAgMCAwLjQ0NzU0NSAwIDAuOTk5OTUxQzAgMS41NTIxMyAwLjQ0NTg1NCAxLjk5OTkgMC45OTU2IDEuOTk5OUgxLjk5MTI4VjMuOTk5ODZWOC45OTk5MkMxLjk5MTI4IDEwLjEwNDUgMi44ODI3NCAxMC45OTk5IDMuOTgyNTcgMTAuOTk5OUgxMi45NDM0QzEzLjg5MjcgMTAuOTk5OSAxNC43MDk5IDEwLjMyNyAxNC44OTYgOS4zOTIwMkwxNS44OTE3IDQuMzkyMTVDMTYuMDA4NyAzLjgwNDU4IDE1Ljg1NzIgMy4xOTUxNyAxNS40NzkxIDIuNzMxODZaTTMuOTgyNTcgOC45OTk5MlYzLjk5OTg2SDEzLjkzOUwxMi45NDM0IDguOTk5OTJIMy45ODI1N1pNMi45ODY4OCAxMS45OTk4QzEuODg3MTQgMTEuOTk5OCAwLjk5NTYgMTIuODk1MiAwLjk5NTYgMTMuOTk5OEMwLjk5NTYgMTUuMTA0NSAxLjg4NzE0IDE1Ljk5OTkgMi45ODY4OCAxNS45OTk5QzQuMDg2NzEgMTUuOTk5OSA0Ljk3ODI1IDE1LjEwNDUgNC45NzgyNSAxMy45OTk4QzQuOTc4MjUgMTIuODk1MiA0LjA4NjcxIDExLjk5OTggMi45ODY4OCAxMS45OTk4Wk0xMC45NTIxIDEzLjk5OThDMTAuOTUyMSAxMi44OTUyIDExLjg0MzYgMTEuOTk5OCAxMi45NDM0IDExLjk5OThDMTQuMDQzMSAxMS45OTk4IDE0LjkzNDcgMTIuODk1MiAxNC45MzQ3IDEzLjk5OThDMTQuOTM0NyAxNS4xMDQ1IDE0LjA0MzEgMTUuOTk5OSAxMi45NDM0IDE1Ljk5OTlDMTEuODQzNiAxNS45OTk5IDEwLjk1MjEgMTUuMTA0NSAxMC45NTIxIDEzLjk5OThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K");


/***/ }),

/***/ 21574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SvgTime; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-0.000137329 7.99969C-0.000137329 3.58863 3.58872 -9.15527e-05 7.99985 -9.15527e-05C12.4111 -9.15527e-05 15.9998 3.58863 15.9998 7.99969C15.9998 12.4112 12.4111 15.9997 7.99985 15.9997C3.58872 15.9997 -0.000137329 12.4112 -0.000137329 7.99969ZM1.9998 7.99969C1.9998 11.3134 4.68612 13.9999 7.99985 13.9999C11.3136 13.9999 13.9999 11.3134 13.9999 7.99969C13.9999 4.68626 11.3136 1.99989 7.99985 1.99989C4.68612 1.99989 1.9998 4.68626 1.9998 7.99969ZM8.99997 6.99983H10.9999C11.5526 6.99983 11.9999 7.44777 11.9999 7.99969C11.9999 8.55204 11.5526 8.99981 10.9999 8.99981H7.99985C7.44767 8.99981 6.99982 8.55204 6.99982 7.99969V5.00001C6.99982 4.44766 7.44767 4.00002 7.99985 4.00002C8.55212 4.00002 8.99997 4.44766 8.99997 5.00001V6.99983Z",
  fill: "black"
});

function SvgTime({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0tMC4wMDAxMzczMjkgNy45OTk2OUMtMC4wMDAxMzczMjkgMy41ODg2MyAzLjU4ODcyIC05LjE1NTI3ZS0wNSA3Ljk5OTg1IC05LjE1NTI3ZS0wNUMxMi40MTExIC05LjE1NTI3ZS0wNSAxNS45OTk4IDMuNTg4NjMgMTUuOTk5OCA3Ljk5OTY5QzE1Ljk5OTggMTIuNDExMiAxMi40MTExIDE1Ljk5OTcgNy45OTk4NSAxNS45OTk3QzMuNTg4NzIgMTUuOTk5NyAtMC4wMDAxMzczMjkgMTIuNDExMiAtMC4wMDAxMzczMjkgNy45OTk2OVpNMS45OTk4IDcuOTk5NjlDMS45OTk4IDExLjMxMzQgNC42ODYxMiAxMy45OTk5IDcuOTk5ODUgMTMuOTk5OUMxMS4zMTM2IDEzLjk5OTkgMTMuOTk5OSAxMS4zMTM0IDEzLjk5OTkgNy45OTk2OUMxMy45OTk5IDQuNjg2MjYgMTEuMzEzNiAxLjk5OTg5IDcuOTk5ODUgMS45OTk4OUM0LjY4NjEyIDEuOTk5ODkgMS45OTk4IDQuNjg2MjYgMS45OTk4IDcuOTk5NjlaTTguOTk5OTcgNi45OTk4M0gxMC45OTk5QzExLjU1MjYgNi45OTk4MyAxMS45OTk5IDcuNDQ3NzcgMTEuOTk5OSA3Ljk5OTY5QzExLjk5OTkgOC41NTIwNCAxMS41NTI2IDguOTk5ODEgMTAuOTk5OSA4Ljk5OTgxSDcuOTk5ODVDNy40NDc2NyA4Ljk5OTgxIDYuOTk5ODIgOC41NTIwNCA2Ljk5OTgyIDcuOTk5NjlWNS4wMDAwMUM2Ljk5OTgyIDQuNDQ3NjYgNy40NDc2NyA0LjAwMDAyIDcuOTk5ODUgNC4wMDAwMkM4LjU1MjEyIDQuMDAwMDIgOC45OTk5NyA0LjQ0NzY2IDguOTk5OTcgNS4wMDAwMVY2Ljk5OTgzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==");


/***/ }),

/***/ 47829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SvgWalletSmall; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.9999 15.9687H1.99982C0.895291 15.9687 -0.00012207 15.0733 -0.00012207 13.9686V1.99998C-0.00012207 0.895394 0.895291 0 1.99982 0H13.9999C15.0937 0 15.9796 0.879111 15.9966 1.96874H2.92164C2.37805 1.96874 1.93736 2.40943 1.93736 2.95319C1.93736 3.49665 2.37805 3.93748 2.92164 3.93748H15.9999V9.31593V10.6215V13.9686C15.9999 15.0733 15.1044 15.9687 13.9999 15.9687ZM1.93736 5.96885V9.96881H1.95625C1.95319 10.0011 1.93736 10.0293 1.93736 10.0625V12.9688C1.93736 13.521 2.38502 13.9686 2.93739 13.9686H12.9998C13.5521 13.9686 13.9999 13.521 13.9999 12.9688V11.9686H10.9686C10.4163 11.9686 9.96863 11.3654 9.96863 10.6215V9.31593C9.96863 8.57189 10.4163 7.96883 10.9686 7.96883H13.9999V5.96885H1.93736ZM13.9999 9.96881C13.9999 9.41644 13.5521 8.96882 12.9998 8.96882C12.4475 8.96882 11.9998 9.41644 11.9998 9.96881C11.9998 10.521 12.4475 10.9686 12.9998 10.9686C13.5355 10.9686 13.9645 10.5449 13.9904 10.0157C13.9861 10.0005 13.9825 9.98511 13.9809 9.96881H13.9999Z",
  fill: "black"
});

function SvgWalletSmall({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy45OTk5IDE1Ljk2ODdIMS45OTk4MkMwLjg5NTI5MSAxNS45Njg3IC0wLjAwMDEyMjA3IDE1LjA3MzMgLTAuMDAwMTIyMDcgMTMuOTY4NlYxLjk5OTk4Qy0wLjAwMDEyMjA3IDAuODk1Mzk0IDAuODk1MjkxIDAgMS45OTk4MiAwSDEzLjk5OTlDMTUuMDkzNyAwIDE1Ljk3OTYgMC44NzkxMTEgMTUuOTk2NiAxLjk2ODc0SDIuOTIxNjRDMi4zNzgwNSAxLjk2ODc0IDEuOTM3MzYgMi40MDk0MyAxLjkzNzM2IDIuOTUzMTlDMS45MzczNiAzLjQ5NjY1IDIuMzc4MDUgMy45Mzc0OCAyLjkyMTY0IDMuOTM3NDhIMTUuOTk5OVY5LjMxNTkzVjEwLjYyMTVWMTMuOTY4NkMxNS45OTk5IDE1LjA3MzMgMTUuMTA0NCAxNS45Njg3IDEzLjk5OTkgMTUuOTY4N1pNMS45MzczNiA1Ljk2ODg1VjkuOTY4ODFIMS45NTYyNUMxLjk1MzE5IDEwLjAwMTEgMS45MzczNiAxMC4wMjkzIDEuOTM3MzYgMTAuMDYyNVYxMi45Njg4QzEuOTM3MzYgMTMuNTIxIDIuMzg1MDIgMTMuOTY4NiAyLjkzNzM5IDEzLjk2ODZIMTIuOTk5OEMxMy41NTIxIDEzLjk2ODYgMTMuOTk5OSAxMy41MjEgMTMuOTk5OSAxMi45Njg4VjExLjk2ODZIMTAuOTY4NkMxMC40MTYzIDExLjk2ODYgOS45Njg2MyAxMS4zNjU0IDkuOTY4NjMgMTAuNjIxNVY5LjMxNTkzQzkuOTY4NjMgOC41NzE4OSAxMC40MTYzIDcuOTY4ODMgMTAuOTY4NiA3Ljk2ODgzSDEzLjk5OTlWNS45Njg4NUgxLjkzNzM2Wk0xMy45OTk5IDkuOTY4ODFDMTMuOTk5OSA5LjQxNjQ0IDEzLjU1MjEgOC45Njg4MiAxMi45OTk4IDguOTY4ODJDMTIuNDQ3NSA4Ljk2ODgyIDExLjk5OTggOS40MTY0NCAxMS45OTk4IDkuOTY4ODFDMTEuOTk5OCAxMC41MjEgMTIuNDQ3NSAxMC45Njg2IDEyLjk5OTggMTAuOTY4NkMxMy41MzU1IDEwLjk2ODYgMTMuOTY0NSAxMC41NDQ5IDEzLjk5MDQgMTAuMDE1N0MxMy45ODYxIDEwLjAwMDUgMTMuOTgyNSA5Ljk4NTExIDEzLjk4MDkgOS45Njg4MUgxMy45OTk5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==");


/***/ }),

/***/ 3601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BreadCrumb_BreadCrumb; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/assets/svg/breadcrumb_arrow.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.735073 8.99938C0.924127 8.99938 1.11306 8.9236 1.2568 8.77149L4.78616 5.04303C5.071 4.7426 5.071 4.25676 4.78616 3.95597L1.2568 0.22732C0.970702 -0.07508 0.505042 -0.0767 0.21688 0.22354C-0.0711648 0.523612 -0.0728838 1.01234 0.213334 1.31438L3.22816 4.4994L0.213334 7.68443C-0.0728838 7.98684 -0.0711648 8.4752 0.21688 8.77545C0.360277 8.92486 0.547729 8.99938 0.735073 8.99938Z",
  fill: "#969696"
});

function SvgBreadcrumbArrow({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var breadcrumb_arrow = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgNSA5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuNzM1MDczIDguOTk5MzhDMC45MjQxMjcgOC45OTkzOCAxLjExMzA2IDguOTIzNiAxLjI1NjggOC43NzE0OUw0Ljc4NjE2IDUuMDQzMDNDNS4wNzEgNC43NDI2IDUuMDcxIDQuMjU2NzYgNC43ODYxNiAzLjk1NTk3TDEuMjU2OCAwLjIyNzMyQzAuOTcwNzAyIC0wLjA3NTA4IDAuNTA1MDQyIC0wLjA3NjcgMC4yMTY4OCAwLjIyMzU0Qy0wLjA3MTE2NDggMC41MjM2MTIgLTAuMDcyODgzOCAxLjAxMjM0IDAuMjEzMzM0IDEuMzE0MzhMMy4yMjgxNiA0LjQ5OTRMMC4yMTMzMzQgNy42ODQ0M0MtMC4wNzI4ODM4IDcuOTg2ODQgLTAuMDcxMTY0OCA4LjQ3NTIgMC4yMTY4OCA4Ljc3NTQ1QzAuMzYwMjc3IDguOTI0ODYgMC41NDc3MjkgOC45OTkzOCAwLjczNTA3MyA4Ljk5OTM4WiIgZmlsbD0iIzk2OTY5NiIvPgo8L3N2Zz4K");

// EXTERNAL MODULE: ./src/hooks/index.ts + 3 modules
var hooks = __webpack_require__(88619);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/BreadCrumb/BreadCrumb.tsx









function BreadCrumb({
  breadCrumbs
}) {
  const siteName = (0,hooks/* useSettingItem */.qT)('WEBSITE_NAME');
  const breadCrumbList = [];

  if (siteName) {
    breadCrumbList.push({
      label: siteName,
      url: '/'
    });
  }

  if (breadCrumbs) {
    breadCrumbList.push(...breadCrumbs);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: (breadCrumbList !== null && breadCrumbList !== void 0 ? breadCrumbList : []).map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(Inner, {
      children: [breadCrumbList.length === index + 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
        children: item.label
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        to: item.url,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
          children: item.label
        })
      }), !(breadCrumbList.length === index + 1) && /*#__PURE__*/(0,jsx_runtime.jsx)(SvgBreadcrumbArrow, {})]
    }, index))
  });
}

const Component = styled_components_browser_esm["default"].ul.withConfig({
  displayName: "BreadCrumb__Component",
  componentId: "sc-16duxws-0"
})(["margin-bottom:3px;padding-bottom:3px;white-space:nowrap;overflow:auto;display:flex;align-items:center;margin-top:15px;svg{margin:0 9px;}&::-webkit-scrollbar{-webkit-appearance:none;height:1px;}&::-webkit-scrollbar-thumb{position:absolute;top:0;border-radius:4px;background-color:", ";}"], theme/* colors.grayLighter */.O9.grayLighter);
const Inner = styled_components_browser_esm["default"].li.withConfig({
  displayName: "BreadCrumb__Inner",
  componentId: "sc-16duxws-1"
})(["display:flex;align-items:center;"]);
const Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "BreadCrumb__Label",
  componentId: "sc-16duxws-2"
})(["font-style:normal;font-weight:500;font-size:10px;line-height:18px;color:#7e7e7e;"]);
/* harmony default export */ var BreadCrumb_BreadCrumb = (BreadCrumb);
;// CONCATENATED MODULE: ./src/components/BreadCrumb/index.ts


/***/ }),

/***/ 55864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Helper_Helper; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@tager/web-modules/dist/web-modules.esm.js
var web_modules_esm = __webpack_require__(56640);
// EXTERNAL MODULE: ./src/hooks/index.ts + 3 modules
var hooks = __webpack_require__(88619);
// EXTERNAL MODULE: ./src/components/A1/index.ts
var A1 = __webpack_require__(18176);
// EXTERNAL MODULE: ./src/components/Mts/index.ts + 2 modules
var Mts = __webpack_require__(38365);
// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(64283);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./src/components/Picture.tsx
var Picture = __webpack_require__(97377);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Helper/Helper.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













function Helper() {
  const helperText = (0,hooks/* useSettingItem */.qT)('HELPER_TEXT');
  const helperQuote = (0,hooks/* useSettingItem */.qT)('HELPER_QUOTE');
  const helperNote = (0,hooks/* useSettingItem */.qT)('HELPER_NOTE');
  const helperName = (0,hooks/* useSettingItem */.qT)('HELPER_NAME');
  const helperPosition = (0,hooks/* useSettingItem */.qT)('HELPER_POSITION');
  const a1Number = (0,hooks/* useSettingItem */.qT)('CONTACTS_PHONE_A1');
  const mtsNumber = (0,hooks/* useSettingItem */.qT)('CONTACTS_PHONE_MTS');
  const helperImage = (0,hooks/* useSettingItem */.qT)('HELPER_IMAGE');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(HelperSection, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HelperText, {
        children: helperText
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Phones, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(A1/* default */.Z, {
          title: a1Number
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Mts/* default */.Z, {
          title: mtsNumber
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Person, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HelperQuote, {
          children: helperQuote
        }), helperImage && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPicture, _objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(helperImage)))]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HelperName, {
        children: helperName
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HelperPosition, {
        children: helperPosition
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HelperNote, {
        children: helperNote
      })]
    })
  });
}

/* harmony default export */ var Helper_Helper = (Helper);
const HelperSection = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Helper__HelperSection",
  componentId: "sc-1blwbc3-0"
})([""]);
const Phones = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Helper__Phones",
  componentId: "sc-1blwbc3-1"
})(["max-width:450px;margin-top:13px;display:flex;div{flex:1 1 auto;}& > div:last-child{justify-content:flex-end;}"]);
const HelperText = styled_components_browser_esm["default"].p.withConfig({
  displayName: "Helper__HelperText",
  componentId: "sc-1blwbc3-2"
})(["margin-top:20px;font-style:normal;font-weight:500;font-size:16px;line-height:24px;"]);
const HelperQuote = styled_components_browser_esm["default"].p.withConfig({
  displayName: "Helper__HelperQuote",
  componentId: "sc-1blwbc3-3"
})(["margin-top:15px;font-style:normal;font-weight:500;font-size:11px;line-height:18px;color:", ";flex:1 1 50%;"], theme/* colors.gray700 */.O9.gray700);
const HelperName = styled_components_browser_esm["default"].p.withConfig({
  displayName: "Helper__HelperName",
  componentId: "sc-1blwbc3-4"
})(["margin-top:12px;font-style:normal;font-weight:500;font-size:12px;line-height:18px;"]);
const HelperPosition = styled_components_browser_esm["default"].p.withConfig({
  displayName: "Helper__HelperPosition",
  componentId: "sc-1blwbc3-5"
})(["font-weight:500;font-size:12px;line-height:18px;"]);
const HelperNote = styled_components_browser_esm["default"].p.withConfig({
  displayName: "Helper__HelperNote",
  componentId: "sc-1blwbc3-6"
})(["margin-top:8px;font-weight:500;font-size:12px;line-height:20px;color:", ";"], theme/* colors.gray700 */.O9.gray700);
const StyledPicture = (0,styled_components_browser_esm["default"])(Picture/* default */.Z).withConfig({
  displayName: "Helper__StyledPicture",
  componentId: "sc-1blwbc3-7"
})(["justify-content:flex-end;flex:0 1 50%;img{max-height:100px;}"]);
const Person = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Helper__Person",
  componentId: "sc-1blwbc3-8"
})(["display:flex;align-items:flex-end;max-width:450px;"]);
;// CONCATENATED MODULE: ./src/components/Helper/index.ts


/***/ }),

/***/ 72578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PlainPostCard_PlainPostCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@tager/web-modules/dist/web-modules.esm.js
var web_modules_esm = __webpack_require__(56640);
// EXTERNAL MODULE: ./src/components/Picture.tsx
var Picture = __webpack_require__(97377);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/PlainPostCard/PlainPostCard.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









function PlainPostCard({
  post
}) {
  var _post$image, _post$category;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledPicture, _objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(post === null || post === void 0 ? void 0 : (_post$image = post.image) === null || _post$image === void 0 ? void 0 : _post$image.cover))), /*#__PURE__*/(0,jsx_runtime.jsxs)(Description, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          children: post === null || post === void 0 ? void 0 : post.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
          children: post === null || post === void 0 ? void 0 : post.excerpt
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Category, {
        children: post === null || post === void 0 ? void 0 : (_post$category = post.category) === null || _post$category === void 0 ? void 0 : _post$category.name
      })]
    })
  });
}

/* harmony default export */ var PlainPostCard_PlainPostCard = (PlainPostCard);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlainPostCard__Component",
  componentId: "sc-k7pug5-0"
})(["position:relative;"]);
const StyledPicture = (0,styled_components_browser_esm["default"])(Picture/* default */.Z).withConfig({
  displayName: "PlainPostCard__StyledPicture",
  componentId: "sc-k7pug5-1"
})(["width:100%;height:50%;picture,img{width:100%;height:100%;}img{object-fit:cover;height:130px;@media (min-width:1024px){object-fit:cover;}}"]);
const Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlainPostCard__Content",
  componentId: "sc-k7pug5-2"
})(["height:290px;border:1px solid ", ";"], theme/* colors.grayProductCard */.O9.grayProductCard);
const Description = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlainPostCard__Description",
  componentId: "sc-k7pug5-3"
})(["padding:10px 16px 40px;height:50%;display:flex;flex-direction:column;justify-content:space-between;"]);
const Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlainPostCard__Title",
  componentId: "sc-k7pug5-4"
})(["font-style:normal;font-weight:500;font-size:16px;line-height:24px;@media (min-width:", "){font-size:17px;}overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const SubTitle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlainPostCard__SubTitle",
  componentId: "sc-k7pug5-5"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:20px;margin-top:15px;@media (min-width:", "){font-size:13px;}overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Category = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlainPostCard__Category",
  componentId: "sc-k7pug5-6"
})(["position:absolute;right:0;bottom:0;line-height:30px;font-size:13px;padding:0 20px;background:var(--main-color,#860935);color:", ";&:hover{background:var(--main-color-hover,#6a072a);}"], theme/* colors.white */.O9.white);
;// CONCATENATED MODULE: ./src/components/PlainPostCard/index.ts


/***/ }),

/***/ 50819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductCard_ProductCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@tager/web-modules/dist/web-modules.esm.js
var web_modules_esm = __webpack_require__(56640);
// EXTERNAL MODULE: ./src/components/Picture.tsx
var Picture = __webpack_require__(97377);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(29116);
// EXTERNAL MODULE: ./src/hooks/index.ts + 3 modules
var hooks = __webpack_require__(88619);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ProductCard/ProductCard.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












function ProductCard({
  name,
  price,
  image,
  category,
  discountPrice
}) {
  const currency = (0,hooks/* useSettingItem */.qT)('CURRENCY');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledPicture, _objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(image))), /*#__PURE__*/(0,jsx_runtime.jsxs)(Description, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Top, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Category, {
          children: category
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          children: name
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Bottom, {
        children: price && discountPrice ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [price !== discountPrice && /*#__PURE__*/(0,jsx_runtime.jsxs)(Price, {
            children: [(0,common/* normalizePrice */.nQ)(price), " ", currency]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Discount, {
            children: [(0,common/* normalizePrice */.nQ)(discountPrice), " ", currency]
          })]
        }) : price && !discountPrice ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Discount, {
            children: [(0,common/* normalizePrice */.nQ)(price), " ", currency]
          })
        }) : null
      })]
    })]
  });
}

/* harmony default export */ var ProductCard_ProductCard = (ProductCard);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCard__Component",
  componentId: "sc-5kkfc5-0"
})(["padding:10px 15px;display:flex;flex-direction:column;height:288px;border:1px solid ", ";"], theme/* colors.grayProductCard */.O9.grayProductCard);
const StyledPicture = (0,styled_components_browser_esm["default"])(Picture/* default */.Z).withConfig({
  displayName: "ProductCard__StyledPicture",
  componentId: "sc-5kkfc5-1"
})(["width:100%;height:100%;picture,div,img{width:100%;height:120px;}img{object-fit:contain;object-position:left;}"]);
const Description = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCard__Description",
  componentId: "sc-5kkfc5-2"
})(["flex:1;display:flex;flex-direction:column;justify-content:space-between;"]);
const Category = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCard__Category",
  componentId: "sc-5kkfc5-3"
})(["font-size:12px;line-height:26px;color:#5a5a5a;font-weight:500;@media (min-width:", "){font-size:14px;}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCard__Title",
  componentId: "sc-5kkfc5-4"
})(["font-size:14px;line-height:26px;color:#000;font-weight:500;@media (min-width:", "){font-size:16px;}"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Price = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCard__Price",
  componentId: "sc-5kkfc5-5"
})(["color:rgb(102,102,102);font-size:16px;font-weight:500;text-decoration:line-through;display:block;margin-top:20px;"]);
const Discount = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCard__Discount",
  componentId: "sc-5kkfc5-6"
})(["display:inline-block;font-size:20px;line-height:26px;color:", ";font-weight:500;@media (min-width:", "){font-size:22px;}"], theme/* colors.black */.O9.black, theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Top = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCard__Top",
  componentId: "sc-5kkfc5-7"
})([""]);
const Bottom = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCard__Bottom",
  componentId: "sc-5kkfc5-8"
})([""]);
;// CONCATENATED MODULE: ./src/components/ProductCard/index.ts


/***/ }),

/***/ 31346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ getQuarterToString; },
/* harmony export */   "e": function() { return /* binding */ getFinalPrice; }
/* harmony export */ });
function getQuarterToString(n, rate) {
  return Number(Math.floor(n * (rate / 100)).toFixed());
}
function getFinalPrice(sum, rate, initPayment, period) {
  const rateToUse = rate / 100;
  const priceWithoutInitPayment = sum - Math.floor(initPayment);
  const priceLeftToPayWithRate = Number((rateToUse > 0 ? priceWithoutInitPayment * rateToUse + priceWithoutInitPayment : priceWithoutInitPayment).toFixed(2));
  const underpayment = Number((priceLeftToPayWithRate - priceWithoutInitPayment).toFixed(2));
  const monthlyPayment = Number((priceLeftToPayWithRate / period).toFixed(2));

  if (initPayment > sum) {
    return {
      price: sum,
      underpayment: 0,
      monthlyPayment: 0
    };
  }

  return {
    price: sum + underpayment,
    underpayment,
    monthlyPayment
  };
}

/***/ }),

/***/ 44260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ActionType; }
/* harmony export */ });
let ActionType;

(function (ActionType) {
  ActionType["SETPERIOD"] = "setPeriod";
  ActionType["SETPRICE"] = "setPrice";
  ActionType["SETINITPAYMENTRATE"] = "setInitPaymentRate";
  ActionType["SETRATE"] = "setRate";
  ActionType["SETINITIALPAYMENT"] = "setInitialPayment";
})(ActionType || (ActionType = {}));

/***/ }),

/***/ 34340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tager/web-components/dist/web-components.esm.js
var web_components_esm = __webpack_require__(63394);
// EXTERNAL MODULE: ./src/components/Layout/index.ts
var Layout = __webpack_require__(41880);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/production/index.js
var production = __webpack_require__(1617);
// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(64283);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/modules/NotFound/NotFound.tsx









function NotFound() {
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Inner, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextError, {
          children: "404"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextPageNotFound, {
          children: t('errors.404_title')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
          to: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonLink, {
            children: t('errors.go_to_home')
          })
        })]
      })
    })
  });
}

/* harmony default export */ var NotFound_NotFound = (NotFound);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "NotFound__Component",
  componentId: "sc-19kmbfl-0"
})(["height:100%;display:flex;align-items:center;"]);
const Inner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "NotFound__Inner",
  componentId: "sc-19kmbfl-1"
})(["text-align:center;padding:20px 0 10px 0;"]);
const TextError = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "NotFound__TextError",
  componentId: "sc-19kmbfl-2"
})(["font-size:44px;margin:0;"]);
const TextPageNotFound = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "NotFound__TextPageNotFound",
  componentId: "sc-19kmbfl-3"
})(["font-size:36px;margin:0 0 30px;"]);
const ButtonLink = styled_components_browser_esm["default"].button.withConfig({
  displayName: "NotFound__ButtonLink",
  componentId: "sc-19kmbfl-4"
})(["border:1px solid ", ";color:", ";font-weight:600;border-radius:5px;width:230px;line-height:38px;&:hover{background:", ";color:", ";}"], theme/* colors.primary */.O9.primary, theme/* colors.primary */.O9.primary, theme/* colors.primary */.O9.primary, theme/* colors.white */.O9.white);
;// CONCATENATED MODULE: ./src/modules/NotFound/index.ts

;// CONCATENATED MODULE: ./src/pages/404.tsx






function NotFoundPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(web_components_esm/* Page */.T3, {
    title: "Page not found",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NotFound_NotFound, {})
    })
  });
}

/* harmony default export */ var _404 = (NotFoundPage);

/***/ }),

/***/ 35635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _sentry_node__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24403);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);
/* harmony import */ var _tager_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63394);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






function ErrorPage({
  statusCode,
  title,
  isInitProps,
  errorId,
  err
}) {
  if (!isInitProps && !errorId && err) {
    // getInitialProps is not called in case of
    // https://github.com/zeit/next.js/issues/8592. As a workaround, we pass
    // err via _app.js so it can be captured
    errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
  }

  const errorCode = statusCode !== null && statusCode !== void 0 ? statusCode : 500;
  const errorName = err !== null && err !== void 0 && err.name ? err.name.replace(/\.$/, '') : title !== null && title !== void 0 ? title : 'JavaScript Error';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tager_web_components__WEBPACK_IMPORTED_MODULE_2__/* .Page */ .T3, {
    title: "An error occurred",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tager_web_components__WEBPACK_IMPORTED_MODULE_2__/* .ErrorModule */ .TW, {
      errorCode: errorCode,
      errorName: errorName,
      errorId: errorId
    })
  });
}

ErrorPage.getInitialProps = async pageContext => {
  const {
    res,
    err,
    asPath
  } = pageContext;
  const errorInitialProps = await next_error__WEBPACK_IMPORTED_MODULE_1__["default"].getInitialProps(pageContext); // Workaround for https://github.com/zeit/next.js/issues/8592, mark when
  // getInitialProps has run

  errorInitialProps.isInitProps = true;

  if (res) {
    // Running on the server, the response object is available.
    //
    // Next.js will pass an err on the server if a page's `getInitialProps`
    // threw or returned a Promise that rejected
    if (res.statusCode === 404) {
      // Opinionated: do not record an exception in Sentry for 404
      return {
        statusCode: 404
      };
    }

    if (err) {
      errorInitialProps.errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
      return errorInitialProps;
    }
  } else {
    // Running on the client (browser).
    //
    // Next.js will provide an err if:
    //
    //  - a page's `getInitialProps` threw or returned a Promise that rejected
    //  - an exception was thrown somewhere in the React lifecycle (render,
    //    componentDidMount, etc) that was caught by Next.js's React Error
    //    Boundary. Read more about what types of exceptions are caught by Error
    //    Boundaries: https://reactjs.org/docs/error-boundaries.html
    if (err) {
      errorInitialProps.errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
      return errorInitialProps;
    }
  } // If this point is reached, getInitialProps was called without any
  // information about what the error might be. This is unexpected and may
  // indicate a bug introduced in Next.js, so record it in Sentry


  errorInitialProps.errorId = _sentry_node__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(new Error(`_error.js getInitialProps missing data at path: ${asPath}`));
  return errorInitialProps;
};

/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);

/***/ }),

/***/ 26625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ getSharedThunkList; }
/* harmony export */ });
/* harmony import */ var _store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67463);
/* harmony import */ var _store_reducers_tager_settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35439);
/* harmony import */ var _store_reducers_pages_products__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13006);
/* harmony import */ var _store_reducers_tager_blog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44272);




function getSharedThunkList(dispatch) {
  return [dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('top')), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('main')), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('footer')), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getMenuItemListThunk */ .up)('catalog')), dispatch((0,_store_reducers_pages_products__WEBPACK_IMPORTED_MODULE_2__/* .getProductListByGroupThunk */ .fd)('TOP')), dispatch((0,_store_reducers_pages_products__WEBPACK_IMPORTED_MODULE_2__/* .getProductListByGroupThunk */ .fd)('NEW')), dispatch((0,_store_reducers_tager_settings__WEBPACK_IMPORTED_MODULE_1__/* .getSettingItemListThunk */ .rT)()), dispatch((0,_store_reducers_tager_menus__WEBPACK_IMPORTED_MODULE_0__/* .getCatalogMenuThunk */ .ke)()), dispatch((0,_store_reducers_tager_blog__WEBPACK_IMPORTED_MODULE_3__/* .getBlogPostListThunk */ .R3)())];
}

/***/ })

}]);